import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { SettingService } from '../app/business-services/setting.service';
import { Features } from './business-entities/step.class';
import * as Enums from '../../../Autofacets-Core/src/app/utils/enums';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { CustomerService } from './business-services/customer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'Widget';
  features: Features[] = [];
  globalizationValues: any;
  currentYear: number;
  public showServiceUnavailableBanner = false;
  selectedLangExpireDate = new Date();
  widgetContacUsLink: string;
  constructor(
    private readonly settingService: SettingService,
    private readonly globalSetting: GlobalSetting,
    public spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly cookieService: CookieService, 
    private readonly secureStorage: SecureStorage,
    private readonly currentLanguage: CurrentLanguage,
    private readonly service: CustomerService
  ) {

  }
  ngOnInit() {
    this.globalSetting.isAuthenticated.subscribe((res) => {
      if (res) {
        this.GetFeature();
      }
    });

    this.currentYear = new Date().getFullYear();
    this.translate.setDefaultLang('en-US');
    if (this.isCookiesExist()) {
      this.translate.use(this.cookieService.get('userSelectedLanguage'));
    }
    else if (EnvSetting.language.LanguageOverRule) {
      this.cookieService.set('userSelectedLanguage', EnvSetting.language.LanguageOverRuleDefault, this.selectedLangExpireDate, '/', '', false, "Strict");
      this.currentLanguageService.currentLanguage.next(EnvSetting.language.LanguageOverRuleDefault);
      this.translate.use(EnvSetting.language.LanguageOverRuleDefault);
    }
    else {
      this.cookieService.set('userSelectedLanguage', 'en-US');
      this.translate.setDefaultLang('en-US');
      this.translate.use('en-US');
    }
    if (sessionStorage.getItem('showBanner') !== null) {
      this.showServiceUnavailableBanner = true;
    } else {
      this.showServiceUnavailableBanner = false;
    }
    if (localStorage.getItem('showBanner') == 'false') {
      this.showServiceUnavailableBanner = true;
    }
    this.widgetContacUsLink = EnvSetting.WidgetContacUsLink;
  }

  public bannerClosed(): void {
    this.showServiceUnavailableBanner = true;
  }

  private isCookiesExist(): boolean {
    return this.cookieService.check('userSelectedLanguage');
  }

  async GetFeature() {
    this.secureStorage.removeKey('feature');
    this.spinner.show();
    if (this.settingService.features.length === 0) {
      await this.settingService.getFeatures().then((res) => {
        if (res.responseObject.errorCount === 0) {
          this.settingService.features = res.responseObject.result;
          this.currentLanguage.featureList.next(this.settingService.features);
        }
      })
    }
    this.features = this.settingService.features;
    if (this.features && this.features.length > 0) {
      this.secureStorage.setKeyData('feature', this.features);
      this.currentLanguage.featureList.next(this.features);
      if (this.secureStorage.getKeyData('feature')) {
        this.features = this.secureStorage.getKeyData('feature');
      }
    }
    const gtmFeature = this.features.find(x => x.featureCode === Enums.FeatureCode.GoogleTagManager);
    this.injectGoogleTagManager(gtmFeature);

    this.spinner.hide();
  }
  injectGoogleTagManager(feature) {
    if (feature?.isActive) {
      let existing = document.getElementById("tagmanager");
      if (existing?.parentNode) {
        existing.parentNode.removeChild(existing);
      }
      let node = document.createElement('script');
      node.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})
      (window,document,'script','dataLayer','`+ feature.serviceUrl1 + `');`;

      node.type = 'text/javascript';
      node.async = true;
      node.setAttribute("id", "tagmanager");
      document.getElementsByTagName('head')[0].prepend(node);

      let noscript = document.createElement('noscript');
      let iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + feature.serviceUrl1;
      iframe.height = "0";
      iframe.width = "0";
      iframe.setAttribute("style", "display:none;visibility:hidden");
      noscript.append(iframe);
      document.getElementsByTagName('body')[0].prepend(noscript);
    }
  }
  getPostCodes() {
    this.service.GetPostCodeDropdown().then((response) => {
      if (response?.responseObject?.length > 0) {
        this.secureStorage.setKeyData("postCodes", response.responseObject);
      } else {
        this.secureStorage.removeKey('postCodes');
        console.info('PostCodes not found!');
      }
    }, _error => {
      this.secureStorage.removeKey('postCodes');
    });
  }
}
